import { ApiClient } from "api";
import { AxiosResponse } from "axios";

class CrudService {
  private constructor() {}

  private static instance: CrudService;

  public static getInstance(): CrudService {
    if (!CrudService.instance) {
      CrudService.instance = new CrudService();
    }
    return CrudService.instance;
  }

  public async create<T>(url: string, data: T): Promise<AxiosResponse<T>> {
    return ApiClient.post<T>(url, data);
  }

  public async getAll<T>(url: string): Promise<AxiosResponse<T>> {
    return ApiClient.get<T>(url);
  }

  public async getById<T>(
    url: string,
    id: number | string
  ): Promise<AxiosResponse<T>> {
    return ApiClient.get<T>(`${url}/${id}/`);
  }

  public async update<T>(
    url: string,
    id: number | string,
    data: T
  ): Promise<AxiosResponse<T>> {
    return ApiClient.put<T>(`${url}/${id}/`, data);
  }

  public async patch<T>(
    url: string,
    id: number | string,
    data: Partial<T>
  ): Promise<AxiosResponse<T>> {
    return ApiClient.patch<T>(`${url}/${id}/`, data);
  }

  public async delete(url: string, id: number | string): Promise<void> {
    return ApiClient.delete(`${url}/${id}`);
  }
}

// Export a single instance of ApiService
export const crudService = CrudService.getInstance();
